import React, { useEffect, useState } from 'react';
import ChallengeQuiz from './ChallengeQuiz';
import { useFunnelConfig } from './ThreeJobs';
import { PageCtx, useFunnelContent, pageBg } from './editor/EditableBits';
import { FunnelSections } from './editor/registry';
import { PageWidgets } from './editor/Widgets';
import '../../components/landing/arc/arc.css';

export default function ChallengeLanderPage() {
  const config = useFunnelConfig();
  const pages = useFunnelContent();
  const [quizOpen, setQuizOpen] = useState(false);

  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <PageCtx.Provider value={{ config, handlers: { openQuiz: () => setQuizOpen(true) }, jobs: null }}>
      <div className="min-h-screen arc-bone" style={{ background: pageBg(pages.lander) || undefined }} data-testid="challenge-lander">
        <ChallengeQuiz open={quizOpen} onClose={() => setQuizOpen(false)} />

        <FunnelSections sections={pages.lander} />
        <PageWidgets sections={pages.lander} />

        <footer className="border-t border-black/[0.06] py-8 text-center">
          <p className="arc-body text-xs text-[#141414]/40">© {new Date().getFullYear()} Voxinity AI. All rights reserved.</p>
        </footer>

        {config.test_mode && (
          <div className="fixed bottom-4 left-4 z-50 arc-body rounded-full bg-[#141414] text-[#F0EFEC] text-xs font-bold px-4 py-2 shadow-lg" data-testid="funnel-test-mode-chip">
            TEST MODE
          </div>
        )}
      </div>
    </PageCtx.Provider>
  );
}
